/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { TRUSTED_ORACLE_PROGRAM_ADDRESS } from '../programs';

/** Unauthorized: Unauthorized: only oracle authority can perform this action */
export const TRUSTED_ORACLE_ERROR__UNAUTHORIZED = 0x1770; // 6000
/** AlreadyFinalized: Oracle already finalized */
export const TRUSTED_ORACLE_ERROR__ALREADY_FINALIZED = 0x1771; // 6001
/** InvalidWinningMint: Invalid winning mint */
export const TRUSTED_ORACLE_ERROR__INVALID_WINNING_MINT = 0x1773; // 6003

export type TrustedOracleError =
  | typeof TRUSTED_ORACLE_ERROR__ALREADY_FINALIZED
  | typeof TRUSTED_ORACLE_ERROR__INVALID_WINNING_MINT
  | typeof TRUSTED_ORACLE_ERROR__UNAUTHORIZED;

let trustedOracleErrorMessages: Record<TrustedOracleError, string> | undefined;
if (process.env.NODE_ENV !== 'production') {
  trustedOracleErrorMessages = {
    [TRUSTED_ORACLE_ERROR__ALREADY_FINALIZED]: `Oracle already finalized`,
    [TRUSTED_ORACLE_ERROR__INVALID_WINNING_MINT]: `Invalid winning mint`,
    [TRUSTED_ORACLE_ERROR__UNAUTHORIZED]: `Unauthorized: only oracle authority can perform this action`,
  };
}

export function getTrustedOracleErrorMessage(code: TrustedOracleError): string {
  if (process.env.NODE_ENV !== 'production') {
    return (trustedOracleErrorMessages as Record<TrustedOracleError, string>)[
      code
    ];
  }

  return 'Error message not available in production bundles.';
}

export function isTrustedOracleError<
  TProgramErrorCode extends TrustedOracleError,
>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode,
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    TRUSTED_ORACLE_PROGRAM_ADDRESS,
    code,
  );
}
